/**
 * @module 基础布局（挂载全局组件）
 * @author Yawei Wang
 * @date 2019-06-06 10:01:51
 */
import React, { Fragment, useEffect } from 'react';
// import ModalCenter from 'components/Modal/ModalCenter

export default ({ children }: any) => {
  return (
    <Fragment>
      {children}
      {/* <ModalCenter /> */}
    </Fragment>
  );
};
